import { MenuItem, TextField } from "@material-ui/core";
import { useField, useFormikContext } from "formik";
import { FormLabel } from "./InputField";

export default function FormSelectInput({
  required = false,
  name,
  label,
  fullWidth,
  options,
  commonProps = {},
  ...rest
}) {
  const [field, meta] = useField(name);
  const { value, ...others } = field;
  const formikContext = useFormikContext();
  const { isSubmitting: disabled } = formikContext;
  const errorMessage = meta.error && meta.touched ? meta.error : "";

  return (
    <>
      <div
        className={
          "d-flex flex-column input-margin appbar-div-investor-flow dual-margin-investor-flow"
        }
        style={fullWidth ? { gridColumn: "span 2" } : {}}
      >
        <div className="nps-form-label">
          {label}
          {required && "*"}
        </div>
        <TextField
          label=""
          error={!!errorMessage}
          // onChange={onChange}
          // onBlur={onBlur}
          disabled={disabled}
          value={value}
          variant="outlined"
          // placeholder={placeholder}
          size="small"
          select
          inputProps={
            commonProps.capitalize && {
              style: { textTransform: "uppercase" },
            }
          }
          {...others}
          {...rest}
        >
          <MenuItem value="" disabled>
            Select
          </MenuItem>
          {options.map((_option) => (
            <MenuItem key={_option.value} value={_option.value}>
              {_option.label}
            </MenuItem>
          ))}
        </TextField>
        <div className="nps-error-message">{errorMessage}</div>
      </div>
    </>
  );
}
